/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { List, SiteRedirect, SiteRedirectDestination, SiteRedirectSourcePath } from "./data-contracts";

/**
 * No description
 * @tags site-redirects
 * @name CreateSiteRedirect
 * @summary Create a site redirect
 * @request POST:/orgs/{organizationId}/sites/{siteId}/redirects
 * @secure
 */

// @ts-ignore
export const createSiteRedirect: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The source path to redirect from. */
    source: SiteRedirectSourcePath;
    destination: SiteRedirectDestination;
  };
  RequestHeaders: {};
  ResponseBody: SiteRedirect;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirects",
  method: "post",
  streaming: false,
  tags: ["site-redirects"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-redirects
 * @name ListSiteRedirects
 * @summary List all site redirects
 * @request GET:/orgs/{organizationId}/sites/{siteId}/redirects
 * @secure
 */

// @ts-ignore
export const listSiteRedirects: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Search for a redirect by path */
    search?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: SiteRedirect[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirects",
  method: "get",
  streaming: false,
  tags: ["site-redirects"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-redirects
 * @name UpdateSiteRedirectById
 * @summary Update a site redirect
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}
 * @secure
 */

// @ts-ignore
export const updateSiteRedirectById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site redirect */
    siteRedirectId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The source path to redirect from. */
    source?: SiteRedirectSourcePath;
    destination?: SiteRedirectDestination;
  };
  RequestHeaders: {};
  ResponseBody: SiteRedirect;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}",
  method: "patch",
  streaming: false,
  tags: ["site-redirects"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-redirects
 * @name DeleteSiteRedirectById
 * @summary Delete a site redirect
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}
 * @secure
 */

// @ts-ignore
export const deleteSiteRedirectById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site redirect */
    siteRedirectId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirects/{siteRedirectId}",
  method: "delete",
  streaming: false,
  tags: ["site-redirects"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-redirects
 * @name GetSiteRedirectBySource
 * @summary Get a site redirect by its source
 * @request GET:/orgs/{organizationId}/sites/{siteId}/redirect
 * @secure
 */

// @ts-ignore
export const getSiteRedirectBySource: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
    /** The source path of the redirect. */
    source: SiteRedirectSourcePath;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    redirect: SiteRedirect;
    /** URL of the destination of the redirect. */
    target: string;
  };
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/redirect",
  method: "get",
  streaming: false,
  tags: ["site-redirects"],
  criticalityLevel: "low",
  deprecated: false,
};
